module.exports = __webpack_public_path__ + "media/application/images/icons/play-button-8cac118852dd245d8bce71e66bafe488.svg";